import type { InversionType, ExplorerFilter } from "./chordEngine";

export const INVERSION_LABEL_ES: Record<InversionType, string> = {
  fundamental: "Fundamental",
  first: "1.ª inversión",
  second: "2.ª inversión",
  third: "3.ª inversión",
};

export const INVERSION_HINT_ES: Record<InversionType, string> = {
  fundamental: "La raíz es la nota más grave del acorde.",
  first: "La 3.ª del acorde queda al bajo.",
  second: "La 5.ª del acorde queda al bajo.",
  third: "La 7.ª del acorde queda al bajo.",
};

export const VOICING_TYPE_LABEL_ES: Record<ExplorerFilter["voicingType"], string> = {
  all: "Cerrado",
  close: "Cerrado",
  spread: "Abierto",
  drop2: "Drop 2",
  drop3: "Drop 3",
};

export const CHORD_CATEGORY_LABEL_ES: Record<string, string> = {
  triada: "Tríada",
  tetrada: "Tétrada",
  tension: "Con tensiones",
  alterada: "Alterado",
};

/** Fórmula legible de intervalos en semitonos desde la raíz. */
export function formatChordIntervalFormula(intervals: number[]): string {
  if (intervals.length === 0) return "";
  const parts = intervals.map((semi, i) => (i === 0 ? "R" : `+${semi - intervals[i - 1]}`));
  return parts.join(" · ");
}
